import React from "react";

function RowForm({ label, input, span = 6 }) {
  return (
    <div className={"col-span-12 lg:col-span-"+span+" flex flex-col items-start gap-2"}>
          <span className="text-xl">{label}</span>
      {input}
    </div>
  );
}

export default RowForm;
